import Tobii from '@midzer/tobii';
import '@midzer/tobii/dist/tobii.min.css';

window.addEventListener('DOMContentLoaded', () => {
    new Tobii({
        autoplayVideo: true
    });
});
